import { p as presets } from "../presets-dce40c5a.mjs";
import { m as makeColorsConfig } from "./make-config-a982a813.mjs";
const getColorDefaultConfig = () => makeColorsConfig({
  threshold: 150,
  presets: {
    light: presets.light,
    dark: presets.dark
  },
  currentPresetName: "light"
});
export {
  getColorDefaultConfig as g
};
//# sourceMappingURL=default-600f4ff8.mjs.map
